import { useMutation, UseMutationResult } from '@tanstack/react-query';

import { useAttachmentsConfig } from './useAttachmentsConfig';

export const useFileDelete = (onDeleteSuccess?: () => void): UseMutationResult<void, unknown, string> => {
    const { deleteFile, deleteInternalFile, invalidateCache, isInternalView } = useAttachmentsConfig();

    const deleteFn = isInternalView && deleteInternalFile ? deleteInternalFile : deleteFile;

    const mutation = useMutation({
        mutationFn: (fileId: string) => deleteFn(fileId),
    });

    const mutateAsync = (fileId: string): Promise<void> => {
        return mutation.mutateAsync(fileId, {
            onSuccess: async () => {
                await invalidateCache();
                onDeleteSuccess?.();
            },
        });
    };

    return {
        ...mutation,
        mutateAsync,
    };
};
